import { Toaster as Sonner, toast } from "sonner";
import { useTheme } from "@/lib/theme";

export { toast };

/**
 * Toasts carry transient action outcomes only ("Leave request submitted").
 * Field validation stays inline under the input; page-level failures use
 * <ErrorState /> with a retry.
 */
export function Toaster() {
  const theme = useTheme((s) => s.theme);
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "!rounded-xl !border !border-line !bg-surface !text-ink !shadow-pop !font-sans !text-sm",
          description: "!text-muted",
          actionButton: "!bg-accent !text-accent-ink !rounded-lg",
          cancelButton: "!bg-surface-sunken !text-ink-soft !rounded-lg",
          error: "!border-bad/40",
          success: "!border-good/40",
        },
      }}
    />
  );
}
